var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToiletsWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 22V14.5H4V9C4 7.9 4.9 7 6 7H9C10.1 7 11 7.9 11 9V14.5H9.5V22H5.5ZM18 22V16H21L18.46 8.37C18.3262 7.97171 18.071 7.62536 17.7302 7.37962C17.3894 7.13389 16.9802 7.00113 16.56 7H16.44C16.0195 6.99962 15.6095 7.13179 15.2684 7.37774C14.9274 7.62369 14.6725 7.97089 14.54 8.37L12 16H15V22H18ZM7.5 6C8.61 6 9.5 5.11 9.5 4C9.5 2.89 8.61 2 7.5 2C6.39 2 5.5 2.89 5.5 4C5.5 5.11 6.39 6 7.5 6ZM16.5 6C17.61 6 18.5 5.11 18.5 4C18.5 2.89 17.61 2 16.5 2C15.39 2 14.5 2.89 14.5 4C14.5 5.11 15.39 6 16.5 6Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToiletsWhite);
export default __webpack_public_path__ + "static/media/toilets-white.0390f5c684b2ee978ee0c240a24b211f.svg";
export { ForwardRef as ReactComponent };